export const routePaths = {
  SignIn: "/sign-in",
  signUp: "/sign-up",
  Home: "/",
  AboutUs: "/about-us",
  Policies: "/policies-terms-agreements",
  HealthcareProviders: "/healthcare-providers",
  Pharmaceuticals: "/Pharma",
  Contact: "/contact-us",
  News: "/news",
  Research: "/research",
  PrivacyPolicy: "/documents/privacy-policy",
  download: "/download",
};
